/**
 * Normalize API base URL: trim, drop trailing slashes, collapse accidental `//` in the path
 * (e.g. `...amazonaws.com//dev` → `...amazonaws.com/dev`).
 */
export function normalizeApiBaseUrl(base: string): string {
  const trimmed = base.trim();
  try {
    const u = new URL(trimmed);
    u.pathname = u.pathname.replace(/\/{2,}/g, "/");
    const path = u.pathname.replace(/\/+$/, "");
    return `${u.origin}${path}${u.search}${u.hash}`;
  } catch {
    return trimmed.replace(/\/+$/, "");
  }
}
